import React from 'react';
import { CardBody, Divider } from 'src/components/atoms';
import { StyledSubHeader } from 'src/components/public/MessageSettings/MessageSettings.styles';
import {
  DividerContainer,
  LeftSide,
  RightSide,
  StyledSubDescription,
  StyledSubSection,
} from './ConfigurationsSection.styles';

export const ConfigurationsSection = ({
  first,
  subheader,
  description,
  left = null,
  right = null,
}: {
  first?: boolean;
  subheader: string;
  description?: string | React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
}) => {
  return (
    <>
      {!first && (
        <DividerContainer>
          <Divider variant="horizontal" />
        </DividerContainer>
      )}
      <CardBody>
        <StyledSubSection>
          <LeftSide>
            <StyledSubHeader>{subheader}</StyledSubHeader>
            {description && (
              <StyledSubDescription>{description}</StyledSubDescription>
            )}
            {left}
          </LeftSide>
          <RightSide>{right}</RightSide>
        </StyledSubSection>
      </CardBody>
    </>
  );
};
